"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPqlFormData = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _getScopedProducts = _interopRequireDefault(require("ui-addon-upgrades/_core/common/adapters/getScopedProducts"));

var _productUpgradeInterest = require("../upgradeData/properties/productUpgradeInterest");

var getFieldDataFromOptions = function getFieldDataFromOptions(options) {
  var _options$phoneNumberS = options.phoneNumberSubmitted,
      phoneNumberSubmitted = _options$phoneNumberS === void 0 ? false : _options$phoneNumberS,
      phoneNumber = options.phoneNumber,
      emailSubject = options.emailSubject,
      emailBody = options.emailBody;
  var fieldData = [{
    name: 'pql_phone_number_submitted',
    value: phoneNumberSubmitted
  }];

  if (phoneNumber) {
    fieldData.push({
      name: 'phone',
      value: phoneNumber
    });
  } // Email fields


  if (emailSubject && emailBody) {
    fieldData.push({
      name: 'pql_message_type',
      value: emailSubject
    }, {
      name: 'pql_message_content',
      value: emailBody
    });
  }

  return fieldData;
};
/**
 * @param {Object}
 * @return {String}
 */


var createPqlFormData = function createPqlFormData() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      metaData = _ref.metaData,
      upgradeData = _ref.upgradeData,
      user = _ref.user,
      portal = _ref.portal,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;

  var portalScopes = (0, _getScopedProducts.default)(portal, user);
  var optionsFieldData = getFieldDataFromOptions(options);
  var bundleUrl = upgradeData.bundleUrl;
  var fieldData = [{
    name: 'email',
    value: user.email
  }, {
    name: 'firstname',
    value: user.first_name
  }, {
    name: 'lastname',
    value: user.last_name
  }, {
    name: 'crm_hub_id',
    value: portal.portal_id
  }, {
    name: 'pql_conversion_date',
    value: metaData.timestamp
  }, {
    name: 'pql_app',
    value: upgradeData.app
  }, {
    name: 'pql_source',
    value: upgradeData.uniqueId
  }, {
    name: 'product_signup',
    value: portalScopes.length > 0 ? portalScopes.join(', ') : ''
  }, {
    name: 'product_upgrade_interest',
    value: _productUpgradeInterest.productUpgradeInterest[upgradeData.upgradeProduct] || 'General'
  }].concat((0, _toConsumableArray2.default)(optionsFieldData));

  if (bundleUrl) {
    fieldData.push({
      name: 'pql_master__c',
      value: bundleUrl
    });
  }

  var pqlFormData = {
    fields: fieldData,
    skipValidation: true
  };
  return pqlFormData;
};

exports.createPqlFormData = createPqlFormData;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/common/data/pqlData/createPqlFormData.js
// module id = 610
// module chunks = 5 6